import React, { useEffect, useState } from "react"; 
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Navigation, Pagination, Autoplay } from "swiper/modules"; 

const LatestOffplanHome = ({ city, home = "Yes" }) => {  
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";
 
  useEffect(() => {
    fetch(`${API}/api/offplanlistingbycity.ashx`, { 
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ city,home })
    }) // 🔁 replace URL
      .then((res) => res.json())
      .then((res) => {
        console.log("API Response:", res);

        // ✅ Handle different API formats safely
        const result = Array.isArray(res) ? res : res.data;

        setCities(result || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setCities([]);
        setLoading(false);
      });
  },  [city,home]);

  // ✅ Loader
  if (loading) {
    return <div className="loader">Loading off plan properties...</div>;
  }

  // ✅ Empty state
  if (!cities.length) {
    return <p>No data found</p>;
  }

  return (
    <div className="wrap-categories-sw wow fadeInUp" data-wow-delay=".2s">
      <Swiper
        spaceBetween={30}
        slidesPerView={6}
        modules={[Navigation, Pagination, Autoplay]} 
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 15 },
          640: { slidesPerView: 1, spaceBetween: 15 },
          768: { slidesPerView: 2, spaceBetween: 30 },
          1024: { slidesPerView: 3, spaceBetween: 30 },
        }}
        className="tf-sw-categories"
      >
        {Array.isArray(cities) &&
          cities.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="homelengo-box">
                                 <div className="archive-top">
                                   <Link className="images-group" to={`/off-plan-property/${item.url}`}>
                                     <div className="images-style">
                                      <img src={item.ImagePath+'/w=421,sharpen=1'} alt={item.title}  className=" ls-is-cached lazyloaded" />
                                     </div>
                                     <div className="top">
                                       <ul className="d-flex gap-6">
                                         <li className="flag-tag primary">
                                          {item.paymentplan} Payment Plan
                                         </li>
                                          <li className="flag-tag style-1">
                                          {item.moveinstatus}
                                         </li>
                                       </ul>
                                     </div>
                                   </Link>
                                 </div>
                                 <div className="archive-bottom">
                                   <div className="content-top">
                                     <h6 className="text-capitalize">
                                       <Link className="link" to={`/off-plan-property/${item.url}`}>
                                        {item.title}
                                       </Link>
                                     </h6>
                                     <p>
                                       <svg
                                         width={16}
                                         height={16}
                                         viewBox="0 0 16 16"
                                         fill="none"
                                         xmlns="http://www.w3.org/2000/svg"
                                       >
                                         <path
                                           d="M10 7C10 7.53043 9.78929 8.03914 9.41421 8.41421C9.03914 8.78929 8.53043 9 8 9C7.46957 9 6.96086 8.78929 6.58579 8.41421C6.21071 8.03914 6 7.53043 6 7C6 6.46957 6.21071 5.96086 6.58579 5.58579C6.96086 5.21071 7.46957 5 8 5C8.53043 5 9.03914 5.21071 9.41421 5.58579C9.78929 5.96086 10 6.46957 10 7Z"
                                           stroke="#000"
                                           strokeWidth="1.5"
                                           strokeLinecap="round"
                                           strokeLinejoin="round"
                                         />
                                         <path
                                           d="M13 7C13 11.7613 8 14.5 8 14.5C8 14.5 3 11.7613 3 7C3 5.67392 3.52678 4.40215 4.46447 3.46447C5.40215 2.52678 6.67392 2 8 2C9.32608 2 10.5979 2.52678 11.5355 3.46447C12.4732 4.40215 13 5.67392 13 7Z"
                                           stroke="#000"
                                           strokeWidth="1.5"
                                           strokeLinecap="round"
                                           strokeLinejoin="round"
                                         />
                                       </svg>
                                      {item.community}, {item.city}
                                     </p>
                                      <ul className="meta-list">
               {(Array.isArray(item.property_type)
                 ? item.property_type
                 : (item.property_type || "").split("|")
               ).map((type, i) => (
                 <li key={i} className="item border">
                   {type.trim()}
                 </li>
               ))}
             </ul>
                               
                                   </div>
                                         <div className="content-bottom mb-10">
                                                <Link  className="whitefont fullwidth" to={`/off-plan-property/${item.url}`}>
                                                <h6 className="price">
                                                Starting From  AED {item.price}
                                                </h6>
                                                </Link>
                                              </div>
                                   <div className="content-bottom ">
                                     <div className="property-icns-w">
                                       <Link to="tel:+971501577822">
                                         {" "}
                                         <i className="icon">
                                           <img src="images/img/phone.svg" />
                                         </i>
                                         Call
                                       </Link>
                                       <Link to="mailto:info@nvrealestate.ae">
                                         {" "}
                                         <i className="icon">
                                           <img src="images/img/email.svg" />
                                         </i>
                                         Email
                                       </Link>
                                       <Link
                                       to={`https://web.whatsapp.com/send?phone=971544544287&text=Hi, I am interested in the listing, ${city.title}, from your website. I would like to get more information, please. Thank you.`}
                                       target="_blank"
                                       >
                                         <i className="icon">
                                           <img src="images/img/whatsapp.svg" />
                                         </i>{" "}
                                         Whatsapp
                                       </Link>
                                     </div>
                                   </div>
                                 </div>
                               </div>
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};

export default LatestOffplanHome;
